import { render, staticRenderFns } from "./FormationsManagerLeftBar.vue?vue&type=template&id=940f8176&"
import script from "./FormationsManagerLeftBar.vue?vue&type=script&lang=js&"
export * from "./FormationsManagerLeftBar.vue?vue&type=script&lang=js&"
import style0 from "./FormationsManagerLeftBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports